import { render, staticRenderFns } from "./CategoryCsvUpload.vue?vue&type=template&id=670440d9"
import script from "./CategoryCsvUpload.vue?vue&type=script&lang=js"
export * from "./CategoryCsvUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports